import React, { useState, memo } from "react";
import IconButton from "@mui/material/IconButton";
import ImportExportIcon from '@mui/icons-material/ImportExport';
import moment from "moment-jalaali";
import Api from "../../../utils/api";
import { Loading } from "../../../components";
import { useSelector } from "react-redux";
import ExcelJS from "exceljs";

const RequestExcelDownload = ({ object, ids }) => {
    const AppState = useSelector((state) => state);
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const params = { ...object, excel_export: 1 };
            if (ids && ids.length > 0) params.ids = ids.join(',');
            const response = await new Api().get("/requests", params);

            if (Array.isArray(response) && response.length) {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Requests');

                worksheet.columns = [
                    { header: 'شماره درخواست', key: 'id', width: 15 },
                    { header: 'اپراتور', key: 'operator', width: 25 },
                    { header: 'بازاریاب', key: 'created_by', width: 25 },
                    { header: 'موضوع درخواست', key: 'category', width: 30 },
                    { header: 'تاریخ درخواست', key: 'created_at', width: 25 },
                    { header: 'وضعیت', key: 'status', width: 20 },
                    { header: 'نتیجه درخواست', key: 'message', width: 40 },
                    { header: 'متن درخواست', key: 'content', width: 50 }
                ];

                response.forEach((entity) => {
                    worksheet.addRow({
                        id: entity.id,
                        operator: entity.operator ? `${entity.operator.name} ${entity.operator.family}` : '-',
                        created_by: entity.created_by ? `${entity.created_by.name} ${entity.created_by.family}` : '-',
                        category: entity.category?.title || '-',
                        created_at: moment(entity.created_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss'),
                        status: AppState.requests.status[entity.status] || '-',
                        message: entity.message || '-',
                        content: entity.content || '-'
                    });
                });

                worksheet.getRow(1).eachCell((cell) => {
                    cell.font = { bold: true, size: 14 };
                    cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFCCEEFF' } };
                    cell.border = {
                        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' }
                    };
                });

                worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                    if (rowNumber > 1) {
                        row.eachCell((cell) => {
                            cell.font = { size: 12 };
                            cell.alignment = { horizontal: 'center', vertical: 'middle' };
                        });
                    }
                });

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `requests_${moment().unix()}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
        } catch (err) {
            console.error('خطا در دریافت یا دانلود درخواست‌ها:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <IconButton onClick={fetchData} disabled={loading}>
                <ImportExportIcon />
            </IconButton>
            {loading && <Loading />}
        </>
    );
};

export default memo(RequestExcelDownload);
